import React, { lazy, Suspense } from 'react'
import { useAuth } from '@web/walter-lib/auth'
import Preloader from './Preloader'

const Content = lazy(() => import('./Content'))

function WalletPage() {
    const { isAuth } = useAuth()

    if (!isAuth) {
        return <Preloader />
    }

    return (
        <Suspense fallback={<Preloader />}>
            <Content />
        </Suspense>
    )
}

export default WalletPage
